/*
 This file is part of GNU Taler
 (C) 2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.
*/

import { TalerError, TranslatedString } from "@gnu-taler/taler-util";
import {
  ErrorLoading,
  useTranslationContext,
} from "@gnu-taler/web-util/browser";
import { VNode, h } from "preact";

export function RetryableError({
  error,
  title,
  onRetry,
}: {
  error: TalerError;
  title: TranslatedString;
  onRetry: () => void | Promise<unknown>;
}): VNode {
  const { i18n } = useTranslationContext();
  return (
    <div>
      <ErrorLoading error={error} title={title} />
      <button
        type="button"
        class="mt-3 font-semibold underline"
        onClick={() => void onRetry()}
      >
        <i18n.Translate>Try again</i18n.Translate>
      </button>
    </div>
  );
}
